export default "__VITE_ASSET__X4mPgRc1__"